export class RdsNativePitrAdvancedConfig {
    'isIamDatabaseAuthenticationEnabled';
    'port';
    'storageType';
    'isDeletionProtectionEnabled';
    'cloudwatchLogExportTypes';
    'isCopyTagsToSnapshotEnabled';
    'isAutoMinorVersionUpgradeEnabled';
    'networkType';
    'domain';
    'domainIamRoleName';
    'optionGroupName';
    'isRestoreToLatest';
    'iops';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isIamDatabaseAuthenticationEnabled",
            "baseName": "isIamDatabaseAuthenticationEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageType",
            "baseName": "storageType",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDeletionProtectionEnabled",
            "baseName": "isDeletionProtectionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchLogExportTypes",
            "baseName": "cloudwatchLogExportTypes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "isCopyTagsToSnapshotEnabled",
            "baseName": "isCopyTagsToSnapshotEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isAutoMinorVersionUpgradeEnabled",
            "baseName": "isAutoMinorVersionUpgradeEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "networkType",
            "baseName": "networkType",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "domainIamRoleName",
            "baseName": "domainIamRoleName",
            "type": "string",
            "format": ""
        },
        {
            "name": "optionGroupName",
            "baseName": "optionGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "isRestoreToLatest",
            "baseName": "isRestoreToLatest",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RdsNativePitrAdvancedConfig.attributeTypeMap;
    }
    constructor() {
    }
}
